export default function GradientBg({ variant = "hero", className = "" }) {
  if (variant === "hero") {
    return (
      <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
        <div className="orb bg-violet w-[520px] h-[520px] -left-32 -top-32" />
        <div className="orb bg-pink w-[420px] h-[420px] right-[-100px] top-40" />
        <div className="orb bg-purple w-[360px] h-[360px] left-1/2 -translate-x-1/2 bottom-[-160px]" />
        <div className="absolute inset-0 grid-bg" />
      </div>
    );
  }
  if (variant === "soft") {
    return (
      <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
        <div className="orb bg-violet w-[380px] h-[380px] -left-40 -top-40 opacity-40" />
        <div className="orb bg-pink w-[280px] h-[280px] right-[-80px] top-24 opacity-40" />
      </div>
    );
  }
  return null;
}
